export const changeDateFromSQL = (date) => {
	const userDateFormat = window.FORMAT_DATE;
	if (date) {
		const dateArray = date.split('-');
		if (userDateFormat === "d-m-Y") {
			return `${dateArray[2]}-${dateArray[1]}-${dateArray[0]}`;
		} else if (userDateFormat === "m-d-Y") {
			return `${dateArray[1]}-${dateArray[2]}-${dateArray[0]}`;
		} else {
			return date;
		}
	} else {
		return '-';
	}
};

//the same code ... just testing
export const changeDateToSQL = (date) => {
	const userDateFormat = window.FORMAT_DATE;
	
	if (date) {
		const dateArray = date.split('-');
		if (userDateFormat === "d-m-Y") {
			return `${dateArray[2]}-${dateArray[1]}-${dateArray[0]}`;
		} else if (userDateFormat === "m-d-Y") {
			return `${dateArray[2]}-${dateArray[0]}-${dateArray[1]}`;
		} else {
			return date;
		}
	} else {
		return '-';
	}
};

export const isValidDate = (date) => {
	return date && Object.prototype.toString.call(date) === "[object Date]" && !isNaN(date);
}

export const getDateTimeFormats = (upperCase = true) => {
	const userDateFormat = window.FORMAT_DATE;
	const userTimeFormat = window.FORMAT_TIME;
	
	let dateFormat = '';
	if (userDateFormat == 'm-d-Y') {
		dateFormat = 'MM-dd-yyyy';
	} else if (userDateFormat == 'Y-m-d') {
		dateFormat = 'yyyy-MM-dd';
	} else {
		dateFormat = 'dd-MM-yyyy';
	}
	
	if (upperCase) {
		dateFormat = dateFormat.toUpperCase();
	}
	
	let timeFormat = '';
	if (userTimeFormat == 'H:i') {
		timeFormat = 'HH:mm:ss';
	}
	
	return { dateFormat, timeFormat };
}